<template>
  <el-dialog
    :title="this.id ? '修改功能参数' : '新增功能参数'"
    @close="handleCancle"
    @closed="reset"
    :close-on-click-modal="false"
    :visible="visible"
    width="500px"
  >
    <el-form ref="parameterForm" :model="parameterForm" :rules="typeFormRules" label-width="110px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="所属设备类型" prop="categoryId">
            <!-- <el-input
              v-if="!isDetail"
              v-model="parameterForm.categoryId"
              :maxlength="50"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ parameterForm.categoryId }}</span> -->
            <el-select
              :loading="categoryListLoading"
              style="width: 100%"
              v-model="parameterForm.categoryId"
              placeholder="请输入"
            >
              <el-option
                v-for="item in categoryList"
                :key="item.id"
                :value="item.id"
                :label="item.title"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="参数名称" prop="functionName">
            <!-- <el-input
              v-if="!isDetail"
              v-model="parameterForm.functionName"
              :maxlength="50"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ parameterForm.functionName }}</span> -->
            <el-input
              v-model="parameterForm.functionName"
              :maxlength="50"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="参数编码" prop="functionNo">
            <!-- <el-input
              v-if="!isDetail"
              :maxlength="50"
              v-model="parameterForm.functionNo"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ parameterForm.functionNo }}</span> -->
            <el-input
              :maxlength="50"
              v-model="parameterForm.functionNo"
              placeholder="请输入"
            ></el-input>
            <NoTips />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="状态" prop="status">
            <!-- <el-radio-group v-if="!isDetail" v-model="parameterForm.status">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">停用</el-radio>
            </el-radio-group>
            <span v-else>{{ parameterForm.status }}</span> -->
            <el-radio-group v-model="parameterForm.status">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancle">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="handleSubmit">确定</el-button>
    </span>
    <el-dialog append-to-body width="400px" title="提示" :visible="pushVisible">
      <el-row>
        <span>新增功能参数成功，确认是否跳转设备品牌。</span>
      </el-row>
      <el-row slot="footer" class="dialog-footer" @close="handleNoPush">
        <el-button @click="handleNoPush">取消</el-button>
        <el-button type="primary" @click="handlePush">确定</el-button>
      </el-row>
    </el-dialog>
    <ValidatPass ref="validatPass" @back="validateBack" />
  </el-dialog>
</template>
<script>
import { isEmpty } from 'lodash';
import deviceParameterApi from 'api/home/device-mangement/device-parameter';
import ValidatPass from '@/components/PermissionPassword/ValidatPass';
import NoTips from '../device-components/NoTips';
import deviceApi from 'api/home/device-mangement';
import regex from '@/config/regex';
export default {
  components: {
    ValidatPass,
    NoTips
  },
  data() {
    const validateNo = (rule, value, callback) => {
      const { noReg } = regex;
      if (!value) {
        callback(new Error('请输入功能参数编码'));
        return;
      }
      if (!noReg.test(value)) {
        callback(new Error('请用拼音或相应英文设置编码，以"_"或"-"进行连接'));
      } else {
        callback();
      }
    };
    return {
      id: '',
      isDetail: false,
      visible: false,
      btnLoading: false,
      categoryListLoading: false,
      categoryList: [],
      parameterForm: {
        categoryId: '',
        functionName: '',
        functionNo: '',
        status: 0
      },
      typeFormRules: {
        categoryId: [{ required: true, message: '请选择设备类型', trigger: 'change' }],
        functionName: [{ required: true, message: '请输入功能参数名称', trigger: 'blur' }],
        functionNo: [{ required: true, validator: validateNo, trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      pushVisible: false
    };
  },
  methods: {
    init(data) {
      this.visible = true;
      this.getCategoryList();
      if (!isEmpty(data)) {
        this.$nextTick(() => {
          this.parameterForm.categoryId = data.categoryId;
          this.parameterForm.functionName = data.functionName;
          this.parameterForm.functionNo = data.functionNo;
          this.parameterForm.status = data.status;
          this.id = data.id;
        });
      }
    },
    handleCancle() {
      this.visible = false;
    },
    handleSubmit() {
      this.$refs.parameterForm.validate(validated => {
        if (!validated) {
          return;
        }
        if (this.id) {
          this.editType();
        } else {
          this.addType();
        }
      });
    },
    addType() {
      this.btnLoading = true;
      deviceParameterApi
        .addDeviceParameter(this.parameterForm)
        .then(res => {
          if (res.data.code !== 200) {
            return;
          }
          this.$message.success('新增功能参数成功');
          this.pushVisible = true;
          this.$emit('back', 0);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    editType() {
      const data = {
        id: this.id,
        ...this.parameterForm
      };
      this.$refs.validatPass.init(data, 9, true);
    },
    handleNoPush() {
      this.pushVisible = false;
      this.visible = false;
    },
    handlePush() {
      this.$router.push({ path: '/home/devicebrand' });
    },
    getCategoryList() {
      this.categoryListLoading = true;
      deviceApi
        .getDeviceTypeList()
        .then(res => {
          this.categoryList = res.data.data.map(item => {
            return {
              id: item.id,
              title: item.categoryName
            };
          });
        })
        .finally(() => {
          this.categoryListLoading = false;
        });
    },
    reset() {
      this.$refs.parameterForm.resetFields();
      this.btnLoading = false;
      this.id = '';
      this.isDetail = false;
      this.pushVisible = false;
    },
    validateBack() {
      this.$message.success('功能参数修改成功');
      this.$emit('back', 1);
      this.visible = false;
    }
  }
};
</script>